exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._23wVesa11cpPM21YjDvJSW{display:-webkit-box;display:-ms-flexbox;display:flex;color:var(--white)!important}", ""]);
// Exports
exports.locals = {
	"newEventButtonIcon": "_23wVesa11cpPM21YjDvJSW"
};